module.exports = __webpack_public_path__ + "img/karaoke.7586069d.jpg";